/** @file fitCanvas: target size and integer upscale for a CSS box at a devicePixelRatio (design 4.5). */
import type { Profile } from '@zilo/pose3d-format/types/profile';
import type { CanvasFit } from '@zilo/pose3d-runtime-babylon/canvas/canvasFit';
import { pixelFit } from '@zilo/pose3d-runtime-babylon/canvas/pixelFit';

/**
 * `devW = floor(cssW dpr)`, `devH = floor(cssH dpr)`; snap `pixel`: `scale = max(1, floor(devH / targetH))`, `none`:
 * 1; width and height by `pixelFit`, CSS size = size * scale / dpr (whole CSS and device pixels).
 */
export function fitCanvas(cssW: number, cssH: number, dpr: number, targetH: number, snap: Profile['snap']): CanvasFit {
  const devW = Math.floor(cssW * dpr);
  const devH = Math.floor(cssH * dpr);
  const scale = snap === 'pixel' ? Math.max(1, Math.floor(devH / targetH)) : 1;
  const width = pixelFit(devW, scale, dpr);
  const height = pixelFit(devH, scale, dpr);
  return { width, height, scale, cssWidth: Math.round((width * scale) / dpr), cssHeight: Math.round((height * scale) / dpr), dpr };
}
